import { Directive, HostBinding, HostListener } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Directive({
    selector: '[luiDialogClose]',
    standalone: false
})
export class DialogCloseDirective {
  @HostBinding('class') hostClass = 'lui-dialog-close';

  @HostListener('click') onClick() {
    this.dialogRef.close();
  }

  constructor(private dialogRef: MatDialogRef<unknown>) {}
}
